import React from 'react';
import clsx from 'clsx';
import { ADivider } from '../../atoms/ADivider/index';
import { MBreadcrumbGroup } from '../../molecules/MBreadcrumbGroup/index';
import { MBreadcrumbGroupBackButtonProps } from '../../molecules/MBreadcrumbGroup/MBreadcrumbGroup.types';
import { MBreadcrumbProps } from '../../molecules/MBreadcrumb/MBreadcrumb.types';
import { OBreadcrumbProps, OBreadcrumbType, OBreadcrumbBackButton } from './OBreadcrumb.types';
import * as Styled from './OBreadcrumb.styles';

const TEST_ID = 'mi-web-ui-kit-OBreadcrumb';
const COMPONENT_NAME = 'o-web-ui-kit-OBreadcrumb';

export const OBreadcrumb: React.FC<OBreadcrumbProps> = ({ type = OBreadcrumbType.NoBorder, mBreadcrumbGroup }) => {
  return (
    <div
      data-testid={TEST_ID}
      data-component-name={COMPONENT_NAME}
      className={clsx('container d-flex align-items-center')}
    >
      <Styled.Wrapper
        className={clsx('col-12 px-0 d-flex flex-column', {
          'pb-3': type === OBreadcrumbType.TopBorder,
          'pt-3': type === OBreadcrumbType.BottomBorder,
          'py-3': type === OBreadcrumbType.NoBorder,
        })}
      >
        {type === OBreadcrumbType.TopBorder && <ADivider />}
        <MBreadcrumbGroup
          backButton={mBreadcrumbGroup?.backButton === true || mBreadcrumbGroup?.backButton === 'true'}
          mButton={extractButtonProps(mBreadcrumbGroup?.mButton)}
          mBreadcrumbMulti={extractBreadcrumbItems(mBreadcrumbGroup?.mBreadcrumbMulti ?? [])}
        />
        {type === OBreadcrumbType.BottomBorder && <ADivider />}
      </Styled.Wrapper>
    </div>
  );
};

function extractButtonProps(mButton: OBreadcrumbBackButton | undefined): MBreadcrumbGroupBackButtonProps {
  return {
    ...(mButton?.buttonText ? { buttonText: mButton?.buttonText } : {}),
    ...(mButton?.ctaLink ? { href: mButton?.ctaLink, isExternal: mButton?.openInANewTab === 'true' } : {}),
  };
}

function extractBreadcrumbItems(
  mBreadcrumbMulti: NonNullable<OBreadcrumbProps['mBreadcrumbGroup']>['mBreadcrumbMulti']
): MBreadcrumbProps[] {
  if (!mBreadcrumbMulti) return [];
  
  return mBreadcrumbMulti.map((item, idx) => ({
    aTextInteractive: {
      text: item.aTextInteractive?.text,
      ...(idx < mBreadcrumbMulti.length - 1 ? { href: item.aTextInteractive?.ctaLink || undefined } : {}),
      ...(idx < mBreadcrumbMulti.length - 1 && item.aTextInteractive?.custom_click_track_value
        ? { custom_click_track_value: item.aTextInteractive.custom_click_track_value }
        : {}),
    },
  }));
}
